import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import './NotFound.css'

function NotFound() {

    // Título propio y noindex para que Google no indexe la página de error
    useEffect(() => {
        document.title = 'Página no encontrada | Drontalia';
        const robots = document.createElement('meta');
        robots.name = 'robots';
        robots.content = 'noindex';
        document.head.appendChild(robots);
        return () => robots.remove();
    }, []);

    return (
        <div className='degradado notfound'>
            <div className='notfound__content'>
                <img className='notfound__img' src='/media/dron-parado.webp' alt='Dron Drontalia aterrizado con las hélices paradas' width='1000' height='667' />
                <span className='notfound__code'>404</span>
                <h1 className='subtitulo tres notfound__title'>EL DRON NO ESTÁ VOLANDO EN ESTE MOMENTO</h1>
                <p className='notfound__text'>
                    La página que buscas no existe o ha cambiado de dirección.
                </p>
                <Link to='/' className='cta'>
                    <span>VOLVER AL INICIO</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </Link>
            </div>
        </div>
    )
}

export default NotFound
